import React from 'react';
import { Button } from '@mui/material';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { formatDateAndTimeUTC } from '../../../utils/helper';
import { ICoupon } from '../../../utils/entities/interface';
import { ToggleCouponStatus } from '../../../services/coupen';
import { ListTable } from '../../molecules/ListTable';

export const CouponList = ({
  coupons,
  onUpdate,
  isLoading,
  headerCells,
  onEdit,
}: {
  coupons: ICoupon[];
  onUpdate: () => void;
  isLoading: boolean;
  headerCells: [string, number][];
  onEdit: (coupon: ICoupon) => void;
}) => {
  const handleConfirm = async (coupon: ICoupon) => {
    if (coupon) {
      try {
        await ToggleCouponStatus(coupon._id);
        onUpdate();
      } catch (error) {
        alert(
          error instanceof Error ? error.message : 'Failed to update status',
        );
      }
    }
  };

  const actions = [
    {
      icon: <BorderColorOutlinedIcon />,
      onClick: (coupon: ICoupon) => onEdit(coupon),
    },
  ];

  return (
    <ListTable
      headerCells={headerCells}
      rows={coupons}
      isLoading={isLoading}
      actions={actions}
      renderCell={(coupon: ICoupon, colIndex: number) => {
        switch (colIndex) {
          case 0:
            return (
              <span className="w-full h-full flex justify-center">
                {coupon.image ? (
                  <img
                    src={coupon.image}
                    alt={coupon.name}
                    className="w-[42px] h-[42px] rounded-full object-cover"
                  />
                ) : (
                  '--'
                )}
              </span>
            );
          case 1:
            return coupon.couponCode || 'N/A';
          case 2:
            return coupon.name;
          case 3:
            return coupon.discount != null ? `${coupon.discount}%` : 'N/A';
          case 4:
            return coupon.minValue != null ? `£${coupon.minValue}` : 'N/A';
          case 5:
            return Array.isArray(coupon.description)
              ? coupon.description.join(', ') || 'N/A'
              : coupon.description || 'N/A';
          case 6:
            return formatDateAndTimeUTC(coupon.expiryDate);
          case 7:
            return (
              <Button
                variant="outlined"
                size="small"
                color={coupon.isActive ? 'error' : 'success'}
                onClick={() => handleConfirm(coupon)}
                sx={{
                  textTransform: 'none',
                  fontSize: '0.8rem',
                  borderRadius: '8px',
                }}
              >
                {coupon.isActive ? 'Disable' : 'Enable'}
              </Button>
            );
          default:
            return null;
        }
      }}
    />
  );
};
